export default "__VITE_ASSET__BETdCsEV__"